import React, { useState, useEffect } from "react";
import AddTitleBar from "../../components/titleBar/add_titleBar";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import {
  Form as FormUi,
  Container,
  TextArea,
  Button,
  Input,
  Segment,
  Dropdown,
  Header,
  Modal,
  Table,
  Icon,
  Search,
} from "semantic-ui-react";
import MandatoryMark from "../../components/common/mandatorymark";
import { MyNormalInput, MyInput, MyTextArea } from '../../components/dynamicComponent/myInputs'
import DatePicker from "react-datepicker";
import ReadAxios from "../../components/axiosComponent/read";
import { isEmpty, values } from "lodash";
import axios from 'axios'
import { LOCAL_STORAGE } from '../../utils/constant'
import { REQUIRED_FIELDS, INVALID_FIELDS } from '../../utils/validationConstant'
import { AllRegex } from '../../utils/validation'
import AddCity from "../../components/dynamicComponent/addCity";
import MyState from "../../components/apiInputs/myState";
import {extend} from './ewayBillContants'
import cogoToast from "cogo-toast";

const ExtendEwayBill = ({
  values,
  extendData,
  touched,
  errors,
  openBox,
  handleClose,
  handleSubmit,
  setFieldValue
}) => {
  useEffect(() => {
    getReasons()
    getTransitTypes()
    getConsignmentStatus()

  }, [])

  const [reasons, setReasons] = useState([])
  const [transitTypes, setTransitTypes] = useState([])
  const [consignmentStatus, setConsignmentStatus] = useState([])
  const [loader, setLoader] = useState(true)
  const [vehicleNo, setVehicleNo] = useState('')


  const getReasons = () => {
    let congData = JSON.stringify
      ({
        customerNo: LOCAL_STORAGE.customerNo
      })
    axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getExtendReasonCode`,
      congData, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } }).then((result) => {
        let dataArray = isEmpty(result) ? [] : result.data.data;
        setReasons(
          dataArray.map((item, index) => {
            return {
              raw: { ...item },
              index,
              text: item.extendReasonCodeName,
              key: item.extendReasonCodeId,
              value: item.extendReasonCodeId,
            };
          })
        );
      }).catch((error) => {
        console.log(error);
      })
  }
  const getTransitTypes = () => {
    let congData = JSON.stringify
      ({
        customerNo: LOCAL_STORAGE.customerNo
      })
    axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getTransitType`,
      congData, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } }).then((result) => {
        let dataArray = isEmpty(result) ? [] : result.data.data;
        setTransitTypes(
          dataArray.map((item, index) => {
            return {
              raw: { ...item },
              index,
              text: item.transitTypeName,
              key: item.transitTypeId,
              value: item.transitTypeId,
            };
          })
        );
      }).catch((error) => {
        console.log(error);
      })
  }
  const getConsignmentStatus = () => {
    let congData = JSON.stringify
      ({
        customerNo: LOCAL_STORAGE.customerNo
      })
    axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getConsignmentStatus`,
      congData, { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } }).then((result) => {
        let dataArray = isEmpty(result) ? [] : result.data.data;
        setConsignmentStatus(
          dataArray.map((item, index) => {
            return {
              raw: { ...item },
              index,
              text: item.consignmentStatusName,
              key: item.consignmentStatusId,
              value: item.consignmentStatusId,
            };
          })
        );
      }).catch((error) => {
        console.log(error);
      })
  }
  return (
    <>
      <div>
        <Modal open={openBox} onClose={() => handleClose(null, false)} size="large">
          <>
            <Header>{extend.title||"Extend E-way Bill"}</Header>
            <Modal.Content>
              <Modal.Description>
                <div className="m-2 ui form tiny p-bold-600">
                  <Formiker>
                    <Segment>
                      <FormUi.Group>
                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.ewaybill_no.title||"E-way Bill No"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            name="eway_bill_no"
                            component={MyInput}
                            value={values.eway_bill_no}
                          />
                          {errors.eway_bill_no ? (
                            <div className="w3-small w3-text-red">
                              {errors.eway_bill_no}
                            </div>
                          ) : null}
                        </FormUi.Field>

                        <FormUi.Field width={1} />

                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.vehicle_no.title||"Vehicle Number"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            name="vehicle_number"
                            component={MyInput}
                            value={values.vehicle_number}
                            disabled={true}
                          />
                          {errors.vehicle_number ? (
                            <div className="w3-small w3-text-red">
                              {errors.vehicle_number}
                            </div>
                          ) : null}
                        </FormUi.Field>

                      </FormUi.Group>

                      <FormUi.Group>
                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.from_city.title||"From City"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            type="text"
                            className="cty"
                            component={AddCity}
                            name="cityId"
                            placeholder={extend.from_city.placeholder}
                            namevalue={'cityName'}
                            value={values.cityId}
                          />

                          {errors.cityId ? (
                            <div className="w3-small w3-text-red">
                              {errors.cityId}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />

                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.from_pincode.title||"From City Pincode"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            name="from_pincode"
                            component={MyInput}
                            value={values.from_pincode}
                          />
                          {errors.from_pincode ? (
                            <div className="w3-small w3-text-red">
                              {errors.from_pincode}
                            </div>
                          ) : null}
                        </FormUi.Field>

                      </FormUi.Group>

                      <FormUi.Group>
                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.from_state.title||"From State"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            name="from_state"
                            component={MyState}
                            value={values.from_state}
                          />

                          {errors.from_state ? (
                            <div className="w3-small w3-text-red">
                              {errors.from_state}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />

                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.remaining_distance.title||"Remaining Distance"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            name="remaining_distance"
                            component={MyInput}
                            value={values.remaining_distance}
                          />
                          {errors.remaining_distance ? (
                            <div className="w3-small w3-text-red">
                              {errors.remaining_distance}
                            </div>
                          ) : null}
                        </FormUi.Field>

                      </FormUi.Group>

                      <FormUi.Group>
                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.reason.title||"Reason"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >

                          <Dropdown
                            name="extn_rsn_code"
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            //disabled={disable}
                            selection
                            placeholder={
                              extend.reason.placeholder||"Select Reason"
                            }
                            onChange={(name, data) => {
                              setFieldValue('extn_rsn_code', data.value)
                            }}
                            options={
                              reasons
                            }
                            value={values.extn_rsn_code}
                          />

                          {errors.extn_rsn_code ? (
                            <div className="w3-small w3-text-red">
                              {errors.extn_rsn_code}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />

                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.reason_remark.title||"Reason Remark"}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            name="extn_remarks"
                            component={MyInput}
                            value={values.extn_remarks}

                          />
                          {errors.extn_remarks ? (
                            <div className="w3-small w3-text-red">
                              {errors.extn_remarks}
                            </div>
                          ) : null}
                        </FormUi.Field>

                      </FormUi.Group>



                      <FormUi.Group>
                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.trans_doc_no.title||"Transport Document Number"}{" "}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            name="trans_doc_no"
                            component={MyInput}
                            value={values.trans_doc_no}

                          />

                          {errors.trans_doc_no ? (
                            <div className="w3-small w3-text-red">
                              {errors.trans_doc_no}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />

                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.trans_doc_date.title||"Transport Document Date"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <DatePicker
                            isClearable
                            style={{ width: "100%!important" }}
                            className="form-control width-100cent"
                            dateFormat="dd/MM/yyyy"
                            value={values.trans_doc_date}
                            name='trans_doc_date'
                            onChange={(data) => {
                              setFieldValue('trans_doc_date', moment(data).format("YYYY-MM-DD"))
                            }}
                          />
                          {errors.trans_doc_date ? (
                            <div className="w3-small w3-text-red">
                              {errors.trans_doc_date}
                            </div>
                          ) : null}
                        </FormUi.Field>

                      </FormUi.Group>

                      <FormUi.Group>
                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.transit_type.title||"Transit Type"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Dropdown
                            name="transit_type"
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            selection
                            //disabled={disable}
                            placeholder={
                              extend.transit_type.placeholder||"Select Transit Type"
                            }
                            onChange={(name, data) => {
                              setFieldValue('transit_type', data.value)
                            }}
                            options={transitTypes}
                            value={values.transit_type}
                          />

                          {errors.transit_type ? (
                            <div className="w3-small w3-text-red">
                              {errors.transit_type}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={1} />

                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.consignment_status.title||"Consignment Status"}{" "}
                            <MandatoryMark />
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Dropdown
                            name="consignment_status"
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            //disabled={disable}
                            selection
                            placeholder={
                              extend.consignment_status.placeholder||"Select Status"
                            }
                            onChange={(name, data) => {
                              setFieldValue('consignment_status', data.value)
                            }}
                            options={consignmentStatus}
                            value={values.consignment_status}
                          />
                          {errors.consignment_status ? (
                            <div className="w3-small w3-text-red">
                              {errors.consignment_status}
                            </div>
                          ) : null}
                        </FormUi.Field>

                      </FormUi.Group>

                      <FormUi.Group>
                        <FormUi.Field width={3}>
                          <label className="labelName mt-2">
                            {extend.address.title||"Address"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field
                          width={4}
                        >
                          <Fieldmik
                            name="address"
                            component={MyTextArea}
                            value={values.address}
                          />

                          {errors.address ? (
                            <div className="w3-small w3-text-red">
                              {errors.address}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                    </Segment>
                  </Formiker>
                </div>
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={() => handleClose(null, false)} size="mini">
                {extend.Buttons.cancel||"Cancel"}
              </Button>

              <Button size="mini blue" onClick={handleSubmit} type="submit">
                {extend.Buttons.submit||"Submit"}
              </Button>
            </Modal.Actions>

          </>
        </Modal>
      </div>

    </>
  );
};
const FormikExtendEwayBill = withFormik({
  enableReinitialize: false,
  validationSchema: yup.object().shape({
    eway_bill_no: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    cityId: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    vehicle_number: yup.string().required(REQUIRED_FIELDS.REQUIRED).matches(AllRegex.VehicleNumber, INVALID_FIELDS.INVALID_VEHICLE_NO),
    from_pincode: yup.string().required(REQUIRED_FIELDS.REQUIRED).matches(AllRegex.Pincode, INVALID_FIELDS.INVALID_PINCODE),
    from_state: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    remaining_distance: yup.number(INVALID_FIELDS.INVALID_NUMBER).required(REQUIRED_FIELDS.REQUIRED),
    extn_rsn_code: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    extn_remarks: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    trans_doc_no: yup.string(),
    trans_doc_date: yup.date(INVALID_FIELDS.INVLAID_DATE),
    transit_type: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    consignment_status: yup.string().required(REQUIRED_FIELDS.REQUIRED),
    address: yup.string().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS)

  }),
  mapPropsToValues: (props) => ({
    eway_bill_no: props.extendData && props.extendData.ewbNo ? props.extendData.ewbNo : "",
    vehicle_number: props.extendData && props.extendData.VehiclListDetails[0]?.vehicleNo ? props.extendData.VehiclListDetails[0].vehicleNo : "",
    from_pincode: props.extendData && props.extendData.fromPincode ? props.extendData.fromPincode : "",
    from_state: props.extendData && props.extendData.fromStateCode ? props.extendData.fromStateCode : "",
    remaining_distance:"",
    extn_rsn_code:"",
    extn_remarks:"",
    trans_doc_no: props.extendData && props.extendData.docNo ? props.extendData.docNo : "",
    trans_doc_date: props.extendData && props.extendData.docDate ? moment(props.extendData.docDate, "YYYY-MM-DD").format("YYYY-MM-DD") : "",
    transit_type:"",
    consignment_status:"",
    address:props.extendData && props.extendData.fromAddr1 ?( props.extendData.fromAddr2 ? props.extendData.fromAddr1.toString()+" , "+props.extendData.fromAddr2.toString(): props.extendData.fromAddr1) : (props.extendData.fromAddr2 ? props.extendData.fromAddr2 : "")
  }),

  handleSubmit(values, { setFieldValue, setSubmitting, props }) {
    setSubmitting(true);
    const payload = {
      "customer_no": LOCAL_STORAGE.customerNo,
      "user_id": LOCAL_STORAGE.userId,
      "from_city": values.cityName,
      "from_state_code": values.from_state,
      "address_line_1": values.address,
      "trans_mode": values.transit_type,
      ...values
    }
    axios.post(`${process.env.REACT_APP_TA_API_URL}/Ewaybill/extend`, payload, {
      headers: {
        Accept: "application/json",
        Authorization: `${LOCAL_STORAGE.userToken}`,
        "Access-Control-Allow-Origin": "*"
      },
    }).then((res)=>{
      cogoToast.success(res.data.message,{ position: "top-right"} );
      window.location.reload()
    }).catch((error)=>{
      if (typeof error.response.data.message === "string"){
      cogoToast.error(error.response.data.message, {
        hideAfter: 8,
        position: "top-right",
      });
    }
    else{
      error.response.data.message.forEach((element) => {
        cogoToast.error(`${element.msg} for ${element.param}`, { hideAfter: 8, position: "top-right" });
      });
    }
    })

  },
})(ExtendEwayBill);

export default FormikExtendEwayBill;